import { Tokens } from '@/assets/tokens'
import { Button, Flex, SelectionOption, Selector } from '@/components'
import { Alert, Api } from '@/modules'
import { Close } from '@icon-park/react'
import { useEffect, useState } from 'react'
import { AddThemeContainer, AddThemeOverlay } from './EditModal.styles'

interface AddKeyMessageModalProps {
  companyID: string
  brandID: string
  sourceInternalID: number
  currentKeyMessages: string[]
  onCancel: () => void
  onAdd: (internalID: string, name: string) => void
}

export function AddKeyMessageModal({
  companyID,
  brandID,
  sourceInternalID,
  currentKeyMessages,
  onCancel,
  onAdd,
}: AddKeyMessageModalProps): JSX.Element {
  const { sendAlert } = Alert.Hook()

  const [availableKeyMessages, setAvailableKeyMessages] = useState<SelectionOption[]>([])

  const { binder: bindKeyMessage, selectedOption: selectedKeyMessage } = Selector.Binder()

  const [fetchKeyMessages, isLoadingKeyMessages, keyMessagesData] = Api.LazyQuery<any>(`key-messages`)

  useEffect(() => {
    fetchKeyMessages({
      company: companyID,
      size: 10000,
      brandIDs: brandID,
      sourceInternalID,
    })
  }, [fetchKeyMessages, companyID])

  useEffect(() => {
    if (keyMessagesData?.elements && Array.isArray(keyMessagesData.elements)) {
      const filtered = keyMessagesData.elements
        .filter((km: any) => {
          const isAlreadyUsed = currentKeyMessages.includes(km.internalID)
          return !isAlreadyUsed && km.isActive
        })
        .map((km: any) => ({
          text: km.message,
          value: km.internalID,
        }))

      setAvailableKeyMessages(filtered)
    }
  }, [keyMessagesData?.elements, currentKeyMessages])

  const handleAdd = () => {
    if (!selectedKeyMessage) {
      sendAlert({
        type: 'error',
        title: 'Seleção incompleta',
        message: 'Por favor, selecione uma mensagem-chave.',
      })
      return
    }

    const selectedMessage = availableKeyMessages.find((km) => km.value === selectedKeyMessage.value)?.text || ''

    onAdd(String(selectedKeyMessage.value), selectedMessage)
  }

  return (
    <AddThemeOverlay>
      <AddThemeContainer>
        <Flex $type="row" $justify="center" $align="center" $fit style={{ position: 'relative' }}>
          <h3 style={{ margin: 0, textAlign: 'center', flex: 1 }}>Adicionar Mensagem-Chave</h3>
          <Button.Root $variant="link" onClick={onCancel} style={{ position: 'absolute', right: 0 }}>
            <Button.Icon value={Close} color={Tokens.ColorTextPrimary} />
          </Button.Root>
        </Flex>

        <Flex $type="column" $justify="center" $align="center" $fit $gap={16}>
          <Selector.Default
            {...bindKeyMessage}
            placeholder="Selecionar mensagem-chave"
            options={availableKeyMessages}
            loading={isLoadingKeyMessages}
          />

          {availableKeyMessages.length === 0 && !isLoadingKeyMessages && (
            <p style={{ color: Tokens.ColorTextTertiary, fontSize: '14px', textAlign: 'center', margin: 0 }}>
              Todas as mensagens-chave já estão associadas a esta menção.
            </p>
          )}
        </Flex>

        <Flex $type="row" $justify="center" $align="center" $fit $gap={16}>
          <Button.Root $variant="secondary" onClick={onCancel} style={{ width: '7rem' }}>
            <Button.Text value="Cancelar" />
          </Button.Root>
          <Button.Root
            $variant="primary"
            onClick={handleAdd}
            style={{ width: '7rem' }}
            disabled={!selectedKeyMessage || availableKeyMessages.length === 0}>
            <Button.Text value="Adicionar" />
          </Button.Root>
        </Flex>
      </AddThemeContainer>
    </AddThemeOverlay>
  )
}
